"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.editBaseTokenURIValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
exports.editBaseTokenURIValidationSchema = (0, yup_1.object)().shape({
    baseTokenURI: yup_rules_1.urlValidationSchema,
});
//# sourceMappingURL=validation.js.map